import {useHistory, useLocation} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import {InformationModal} from 'front-onceforall-core';
import {parse} from 'query-string';

function RegistrationMessageView() {
  const history = useHistory();
  const location = useLocation();
  const shouldShowMessage = Boolean(parse(useLocation().search).organisationRegistrationSuccessful);

  return (
    <InformationModal
      isOpen={shouldShowMessage}
      onClose={() => history.replace(location.pathname)}
    >
      <>
        <div className="flex-container center success my-5">
          <h2
            className="m-0"
            style={{textAlign: 'center'}}
          >
            <strong>
              <Translate value="globalDashboard.organisationRegistrationSuccessful.line1"/>
            </strong>
          </h2>
        </div>
        <p className="p-0 m-0">
          <Translate value="globalDashboard.organisationRegistrationSuccessful.line2"/>
        </p>
      </>
    </InformationModal>
  );
}

export default RegistrationMessageView;
